import { BasicDurations } from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import type { LandingParams } from "./types";

export const TRAFFIC_MIN_VALUE = 1000;

export const DEFAULT_PARAMS: LandingParams = Object.freeze({
    country: 999,
    isWWW: "*",
    webSource: devicesTypes.TOTAL,
    duration: BasicDurations.LAST_SIX_MONTHS,
});

export enum FirstLandRoutes {
    OrganicSearchHome = "organicsearch_websiteanalysis_home",
    WebsiteAnalysisHome = "digitalsuite_websiteanalysis_home",
    WebsiteAnalysisSearch = "digitalsuite_website_search_overview",
    OrganicSearchSeo = "organicsearch_seo_overview",
    WebsiteAnalysisWSPerformance = "digitalsuite_website_websiteperformance",
    AiBrandVisibility = "digitalsuite_llm_solutions_homepage",
    RankTrackerHome = "ranktracker.home",
}
